import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { DropOffRequest, DropOffResponse } from '../models/DropOffRequest.model';

@Injectable({
  providedIn: 'root'
})
export class DropOffService {
  private readonly baseUrl = `${environment.apiUrl}/drop-off`;

  constructor(private http: HttpClient) {}

  submitDropOff(request: DropOffRequest): Observable<DropOffResponse> {
    return this.http.post<DropOffResponse>(this.baseUrl, request);
  }
}
